import { useEffect, useState } from "react";
import { filterConstants } from "../../constants";

import { transactionStatus } from "../../enums";
import { useQueryString } from "../../hooks";
import {
  ITransactionBaseDummy,
  IQueryStringNavLinks,
  ITableHeader,
  ITransactionDummy,
} from "../../interfaces-and-types";
import { transactionsData } from "../../test-data";
import { View } from "./View";

export interface ITransactionViewProps {
  data: ITransactionBaseDummy[];
  headers: ITableHeader[];
  isLoading: boolean;
  totalCount: number;
  queryStringTabs: IQueryStringNavLinks;

  // modals
  isCreateNewModalOpen: boolean;
  closeModal: () => void;

  // extra buttons
  onExport: () => void;
  openCreateNewModal: () => void;
}

export const Transactions = () => {
  const [isCreateNewModalOpen, setCreateNewModalOpen] = useState(false);
  const closeModal = () => {
    setCreateNewModalOpen(false);
  };

  const [isLoading, setisLoading] = useState(true);

  const query = useQueryString();
  const status = query.get(filterConstants.statusKey);

  useEffect(() => {
    setTimeout(() => setisLoading(false), 500);
  }, []);

  const headers: ITableHeader[] = [
    {
      key: "amount",
      header: "Amount",
    },
    {
      key: "status",
      header: "Status",
    },
    {
      key: "description",
      header: "Description",
    },
    {
      key: "customer",
      header: "Customer",
    },
    {
      key: "transactionType",
      header: "Transaction Type",
    },
    {
      key: "gateway",
      header: "Gateway",
    },
    {
      key: "date",
      header: "Date",
    },
    {
      key: "more",
      header: "",
    },
  ];

  const queryStringTabs: IQueryStringNavLinks = {
    query: filterConstants.statusKey,
    options: [
      {
        key: "All Transactions",
        value: "",
      },
    ],
  };

  const queryFilteredData = transactionsData.filter(
    (pd) =>
      !status || status === "all" || transactionStatus[pd.status] === status
  );

  const onExport = () => {
    // export data via api and download
    alert("exporting data...");
  };
  const openCreateNewModal = () => {
    // openModal
    setCreateNewModalOpen(true);
  };

  return (
    <View
      data={queryFilteredData}
      headers={headers}
      isLoading={isLoading}
      totalCount={queryFilteredData.length}
      queryStringTabs={queryStringTabs}
      onExport={onExport}
      openCreateNewModal={openCreateNewModal}
      isCreateNewModalOpen={isCreateNewModalOpen}
      closeModal={closeModal}
    />
  );
};
